<remote-login [user]="user"></remote-login>